export const categories = [
  { id: 'all', name: '全部作品', slug: 'all', description: '浏览所有韩国漫画作品，发现你的下一部心头好' },
  { id: 'hot', name: '热门连载', slug: 'hot', description: '最受读者欢迎的连载韩漫，每周准时更新' },
  { id: 'completed', name: '完结经典', slug: 'completed', description: '已完结的高评分韩国漫画，一次看个够' },
  { id: 'romance', name: '恋爱甜宠', slug: 'romance', description: '甜蜜浪漫的韩国恋爱漫画，心动不止' },
  { id: 'fantasy', name: '奇幻冒险', slug: 'fantasy', description: '异世界、魔法与史诗冒险，想象力无边界' },
  { id: 'urban', name: '都市职场', slug: 'urban', description: '现代都市背景下的职场与人生故事' },
  { id: 'thriller', name: '悬疑惊悚', slug: 'thriller', description: '扣人心弦的悬疑推理与惊悚漫画' },
];

export const manhwaList = [
  {
    id: 1,
    title: '社内恋爱法则',
    author: '李智恩',
    category: 'romance',
    status: '连载中',
    rating: 4.8,
    views: 12500000,
    chapters: 87,
    updatedAt: '2026-07-07',
    description: '入职第一天，她发现直属上司竟是大学时期的暗恋对象。原以为可以装作不认识，没想到对方却步步紧逼。办公室里的暧昧气氛逐渐升温，一段让人心跳加速的职场恋情悄然展开。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20art%2C%20romance%20office%20couple%20elegant%20illustration%2C%20warm%20soft%20lighting%2C%20clean%20background%20with%20subtle%20gradient%2C%20digital%20art%20style%2C%20polished%20webtoon%20cover%2C%20professional%20quality%2C%20modern%20romance%20aesthetic&width=800&height=1200&seq=manhwa-cover-01&orientation=portrait',
    chapters_list: [
      { num: 1, title: '第一天上班', date: '2025-03-15' },
      { num: 2, title: '意外的重逢', date: '2025-03-22' },
      { num: 3, title: '深夜加班', date: '2025-03-29' },
      { num: 4, title: '暧昧的开始', date: '2025-04-05' },
      { num: 5, title: '心动的信号', date: '2025-04-12' },
    ],
  },
  {
    id: 2,
    title: '剑与魔法之诗',
    author: '金贤秀',
    category: 'fantasy',
    status: '连载中',
    rating: 4.9,
    views: 18900000,
    chapters: 124,
    updatedAt: '2026-07-06',
    description: '平凡少年意外穿越到剑与魔法的异世界，被赋予拯救王国的使命。在冒险旅途中，他结识了各怀绝技的伙伴，面对黑暗势力的威胁，一段史诗级的奇幻冒险就此展开。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%2C%20warrior%20with%20sword%20in%20magical%20world%2C%20epic%20illustration%2C%20dramatic%20lighting%20with%20warm%20golden%20tones%2C%20digital%20webtoon%20cover%20style%2C%20clean%20gradient%20background%2C%20fantasy%20adventure%20aesthetic&width=800&height=1200&seq=manhwa-cover-02&orientation=portrait',
    chapters_list: [
      { num: 1, title: '异世界的召唤', date: '2024-08-10' },
      { num: 2, title: '命运的相遇', date: '2024-08-17' },
      { num: 3, title: '初战告捷', date: '2024-08-24' },
    ],
  },
  {
    id: 3,
    title: '夜行都市',
    author: '朴志勋',
    category: 'thriller',
    status: '连载中',
    rating: 4.7,
    views: 9800000,
    chapters: 56,
    updatedAt: '2026-07-05',
    description: '首尔深夜的街头，一桩离奇命案牵连出十年的悬案。刑警韩志浩在追查真相的过程中，逐渐发现这个城市不为人知的暗面。每个人都有自己的秘密，而真相往往比想象中更令人胆寒。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20cover%20art%2C%20noir%20cityscape%20night%20scene%2C%20mysterious%20detective%20illustration%2C%20dark%20atmospheric%20lighting%2C%20digital%20webtoon%20cover%20style%2C%20clean%20dark%20gradient%20background%2C%20suspense%20mystery%20aesthetic&width=800&height=1200&seq=manhwa-cover-03&orientation=portrait',
    chapters_list: [
      { num: 1, title: '深夜的报案', date: '2025-06-01' },
      { num: 2, title: '第一具尸体', date: '2025-06-08' },
      { num: 3, title: '疑点重重', date: '2025-06-15' },
    ],
  },
  {
    id: 4,
    title: '甜蜜的陷阱',
    author: '崔秀英',
    category: 'romance',
    status: '已完成',
    rating: 4.6,
    views: 15200000,
    chapters: 95,
    updatedAt: '2025-12-20',
    description: '她本是一个普通的甜品师，直到那天遇见了那位神秘的总裁。以为是命中注定的邂逅，却不知一切早已被精心安排。当甜蜜的陷阱被揭开，她该如何面对这段感情？',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%2C%20elegant%20couple%20in%20patisserie%20setting%2C%20sweet%20warm%20pastel%20color%20palette%2C%20digital%20webtoon%20cover%20style%2C%20soft%20romantic%20lighting%2C%20clean%20gradient%20background%2C%20modern%20romance%20drama%20aesthetic&width=800&height=1200&seq=manhwa-cover-04&orientation=portrait',
    chapters_list: [
      { num: 1, title: '甜蜜日常', date: '2024-01-15' },
      { num: 2, title: '命运相遇', date: '2024-01-22' },
      { num: 3, title: '心动的味道', date: '2024-01-29' },
    ],
  },
  {
    id: 5,
    title: '异能觉醒者',
    author: '郑宇成',
    category: 'fantasy',
    status: '连载中',
    rating: 4.8,
    views: 21000000,
    chapters: 142,
    updatedAt: '2026-07-08',
    description: '在一个普通的世界里，极少数人类突然觉醒了超能力。政府成立特殊机构管理异能者，而主角在觉醒后被迫加入其中。能力越强，责任越大，一场异能者之间的战争即将爆发。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20superpower%20cover%20art%2C%20character%20with%20energy%20powers%20dynamic%20pose%2C%20dramatic%20electric%20lighting%20effects%2C%20digital%20webtoon%20cover%20style%2C%20clean%20dark%20gradient%20background%20with%20glow%2C%20action%20superhero%20aesthetic&width=800&height=1200&seq=manhwa-cover-05&orientation=portrait',
    chapters_list: [
      { num: 1, title: '觉醒之日', date: '2024-06-10' },
      { num: 2, title: '特殊机构', date: '2024-06-17' },
      { num: 3, title: '初次任务', date: '2024-06-24' },
    ],
  },
  {
    id: 6,
    title: '绝美画师',
    author: '尹恩惠',
    category: 'completed',
    status: '已完成',
    rating: 4.9,
    views: 16300000,
    chapters: 78,
    updatedAt: '2025-08-15',
    description: '朝鲜时代一位天才画师的故事。她女扮男装进入宫廷画院，凭借惊艳的才华获得君王赏识。然而身份的隐秘、宫廷的权谋与内心的情感交织，绘就了一幅波澜壮阔的人生画卷。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20cover%20art%2C%20traditional%20Korean%20painter%20in%20hanbok%20elegant%20illustration%2C%20soft%20warm%20ink%20wash%20painting%20style%2C%20digital%20webtoon%20cover%2C%20clean%20parchment%20gradient%20background%2C%20historical%20art%20drama%20aesthetic&width=800&height=1200&seq=manhwa-cover-06&orientation=portrait',
    chapters_list: [
      { num: 1, title: '入宫', date: '2024-03-01' },
      { num: 2, title: '初露锋芒', date: '2024-03-08' },
      { num: 3, title: '君王之眼', date: '2024-03-15' },
    ],
  },
  {
    id: 7,
    title: '王女复国记',
    author: '韩智慧',
    category: 'fantasy',
    status: '连载中',
    rating: 4.7,
    views: 13400000,
    chapters: 68,
    updatedAt: '2026-07-04',
    description: '王国覆灭之夜，年幼的王女在忠诚骑士的保护下逃离。十二年后，她以全新的身份归来，集结旧部、联络盟友，为夺回属于自己的王位而战。权谋与刀光剑影之中，复仇与救赎如影随形。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%2C%20princess%20warrior%20in%20medieval%20armor%20majestic%20illustration%2C%20dramatic%20golden%20hour%20lighting%2C%20digital%20webtoon%20cover%20style%2C%20clean%20royal%20gradient%20background%2C%20epic%20fantasy%20political%20drama%20aesthetic&width=800&height=1200&seq=manhwa-cover-07&orientation=portrait',
    chapters_list: [
      { num: 1, title: '覆灭', date: '2025-05-10' },
      { num: 2, title: '流亡岁月', date: '2025-05-17' },
      { num: 3, title: '归来的王女', date: '2025-05-24' },
    ],
  },
  {
    id: 8,
    title: '末日幸存者',
    author: '宋康昊',
    category: 'thriller',
    status: '连载中',
    rating: 4.5,
    views: 8700000,
    chapters: 45,
    updatedAt: '2026-07-01',
    description: '一场突如其来的病毒席卷全球，感染者在24小时内变异。幸存者们在世界末日的废墟中挣扎求生，而主角意外发现自己对病毒具有免疫力。在绝望与希望之间，人类的最后防线将何去何从？',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20post%20apocalyptic%20cover%20art%2C%20survivor%20in%20ruined%20cityscape%20dramatic%20illustration%2C%20desolate%20atmospheric%20lighting%2C%20digital%20webtoon%20cover%20style%2C%20clean%20dark%20moody%20gradient%20background%2C%20survival%20horror%20aesthetic&width=800&height=1200&seq=manhwa-cover-08&orientation=portrait',
    chapters_list: [
      { num: 1, title: '零号病人', date: '2025-09-05' },
      { num: 2, title: '逃离城市', date: '2025-09-12' },
      { num: 3, title: '避难所', date: '2025-09-19' },
    ],
  },
  {
    id: 9,
    title: '星光咖啡馆',
    author: '林秀晶',
    category: 'urban',
    status: '连载中',
    rating: 4.6,
    views: 7600000,
    chapters: 52,
    updatedAt: '2026-07-08',
    description: '在首尔弘大附近的一条小巷里，有一家只在深夜营业的咖啡馆。每一位走进来的客人都有自己独特的故事，而温柔的店主用一杯咖啡倾听他们的人生。治愈系都市漫画，温暖你的每一个夜晚。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%20art%2C%20cozy%20cafe%20night%20scene%20with%20warm%20lights%2C%20soft%20atmospheric%20illustration%2C%20digital%20webtoon%20cover%20style%2C%20clean%20warm%20gradient%20background%2C%20healing%20urban%20drama%20aesthetic&width=800&height=1200&seq=manhwa-cover-09&orientation=portrait',
    chapters_list: [
      { num: 1, title: '深夜来客', date: '2025-08-20' },
      { num: 2, title: '第一杯咖啡', date: '2025-08-27' },
      { num: 3, title: '她的故事', date: '2025-09-03' },
    ],
  },
  {
    id: 10,
    title: '暗影追踪',
    author: '权相佑',
    category: 'thriller',
    status: '已完成',
    rating: 4.8,
    views: 11500000,
    chapters: 63,
    updatedAt: '2025-06-30',
    description: '前特种部队成员李泰浩退役后成为私家侦探，某天接到一桩看似普通的失踪案。随着调查深入，他发现背后隐藏着一个庞大的跨国犯罪组织。在追踪暗影的过程中，他必须面对过去的创伤和残酷的真相。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20thriller%20cover%20art%2C%20detective%20in%20trench%20coat%20dramatic%20noir%20illustration%2C%20high%20contrast%20shadow%20lighting%2C%20digital%20webtoon%20cover%20style%2C%20clean%20dark%20gradient%20background%2C%20crime%20mystery%20action%20aesthetic&width=800&height=1200&seq=manhwa-cover-10&orientation=portrait',
    chapters_list: [
      { num: 1, title: '新的开始', date: '2024-11-10' },
      { num: 2, title: '失踪少女', date: '2024-11-17' },
      { num: 3, title: '第一线索', date: '2024-11-24' },
    ],
  },
  {
    id: 11,
    title: '魔法学园录',
    author: '张瑞希',
    category: 'fantasy',
    status: '连载中',
    rating: 4.7,
    views: 14200000,
    chapters: 98,
    updatedAt: '2026-07-07',
    description: '收到魔法学园的录取通知书那天，普通高中生金夏恩的人生彻底改变。在这所隐藏于现代都市中的魔法学院里，她将学习掌控元素之力，结识来自世界各地的魔法学徒，并揭开学院尘封千年的秘密。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20magic%20school%20cover%20art%2C%20students%20casting%20spells%20in%20academy%20hall%20vibrant%20illustration%2C%20magical%20glowing%20lighting%20effects%2C%20digital%20webtoon%20cover%20style%2C%20clean%20mystical%20gradient%20background%2C%20fantasy%20school%20adventure%20aesthetic&width=800&height=1200&seq=manhwa-cover-11&orientation=portrait',
    chapters_list: [
      { num: 1, title: '魔法通知书', date: '2025-02-01' },
      { num: 2, title: '学园之门', date: '2025-02-08' },
      { num: 3, title: '元素觉醒', date: '2025-02-15' },
    ],
  },
  {
    id: 12,
    title: '她的秘密花园',
    author: '金泰熙',
    category: 'romance',
    status: '连载中',
    rating: 4.5,
    views: 6800000,
    chapters: 34,
    updatedAt: '2026-07-06',
    description: '因为一次意外，性格内向的园艺师韩素希与当红偶像团体成员开始了同住生活。两个截然不同世界的人，在彼此的秘密花园里种下了爱情的种子。当秘密逐渐被揭开，他们能否守护这份来之不易的感情？',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%2C%20florist%20and%20idol%20in%20garden%20setting%20sweet%20illustration%2C%20soft%20pastel%20spring%20lighting%2C%20digital%20webtoon%20cover%20style%2C%20clean%20floral%20gradient%20background%2C%20modern%20romance%20drama%20aesthetic&width=800&height=1200&seq=manhwa-cover-12&orientation=portrait',
    chapters_list: [
      { num: 1, title: '意外同居', date: '2025-11-01' },
      { num: 2, title: '两个世界', date: '2025-11-08' },
      { num: 3, title: '花园心事', date: '2025-11-15' },
    ],
  },
];

export const testimonials = [
  {
    id: 1,
    name: '漫画迷小王',
    role: '忠实读者·3年',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20man%20portrait%20minimal%20style%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20friendly%20smile%2C%20simple%20casual%20style&width=200&height=200&seq=avatar-user-01&orientation=squarish',
    rating: 5,
    title: '最好的韩漫阅读平台',
    content: '韩漫星球的更新速度真的太快了，每天都忍不住上来看看有没有新章节。下拉式阅读体验很流畅，画质也非常清晰，已经推荐给身边所有喜欢看韩漫的朋友了。',
  },
  {
    id: 2,
    name: '小琳爱看漫画',
    role: 'VIP会员·2年',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%20minimal%20style%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20warm%20smile%2C%20simple%20casual%20style&width=200&height=200&seq=avatar-user-02&orientation=squarish',
    rating: 5,
    title: '资源真的太全了',
    content: '找了好久的一部冷门韩漫居然在这里找到了！分类也很详细，搜索功能很方便。最重要的是完全免费，对于学生党来说真的太友好了。',
  },
  {
    id: 3,
    name: '李大侠',
    role: '资深漫友·5年',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20man%20portrait%20minimal%20style%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20confident%20expression%2C%20simple%20casual%20style&width=200&height=200&seq=avatar-user-03&orientation=squarish',
    rating: 5,
    title: '界面设计很舒服',
    content: '用了很多韩漫网站，韩漫星球是界面最清爽舒服的。分类切换流畅，阅读体验非常好。每天通勤时间都会打开看几章，已经成为我的日常习惯了。',
  },
  {
    id: 4,
    name: '樱花纷飞',
    role: '新读者·6个月',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%20minimal%20style%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20gentle%20smile%2C%20simple%20elegant%20style&width=200&height=200&seq=avatar-user-04&orientation=squarish',
    rating: 4,
    title: '从此入坑韩漫',
    content: '以前只看日漫，朋友推荐来这里看韩漫后完全被吸引了。画风精致，故事节奏紧凑，下拉式阅读方式也非常适合手机浏览。现在已经是韩漫的忠实粉丝了。',
  },
  {
    id: 5,
    name: '夜雨声声',
    role: '活跃读者·1年',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20man%20portrait%20minimal%20style%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20thoughtful%20expression%2C%20simple%20casual%20style&width=200&height=200&seq=avatar-user-05&orientation=squarish',
    rating: 5,
    title: '分类做得特别好',
    content: '最喜欢按心情选分类的功能，想看甜的就点恋爱区，想看刺激的就点悬疑区。推荐算法也很准，经常能发现一些宝藏漫画。',
  },
  {
    id: 6,
    name: '晴天小猪',
    role: '漫画博主·2年',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%20minimal%20style%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20bright%20smile%2C%20simple%20fashion%20style&width=200&height=200&seq=avatar-user-06&orientation=squarish',
    rating: 5,
    title: '博主强烈推荐',
    content: '作为漫画博主，我试过很多平台。韩漫星球的资源量和更新速度在同行中绝对是顶尖的，而且完全免费这一点真的很难得。已经成为我日常更新素材的主要来源。',
  },
];

export const siteStats = {
  totalUsers: 8500000,
  totalManhwa: 3200,
  dailyActiveGrowth: '23.6%',
  totalReads: 520000000,
  partnerPlatforms: 48,
};

export const faqList = [
  {
    question: '韩漫星球是什么？',
    answer: '韩漫星球是一个专注于韩国漫画在线免费阅读的平台，提供最全面的韩漫资源，支持下拉式阅读体验。我们收录了超过3200部韩国漫画作品，涵盖恋爱、奇幻、悬疑、都市等多种类型，每日更新，全部免费阅读。',
  },
  {
    question: '韩漫星球上的漫画真的免费吗？',
    answer: '是的，韩漫星球上所有的漫画资源完全免费阅读。我们致力于为读者提供无障碍的韩漫阅读体验，无需付费即可畅享所有作品。您只需要在网站上浏览即可。',
  },
  {
    question: '网站支持哪些设备阅读？',
    answer: '韩漫星球采用响应式设计，完美适配电脑、平板和手机等各类设备。我们的下拉式阅读方式特别针对手机端进行了优化，让您随时随地都能享受流畅的阅读体验。',
  },
  {
    question: '漫画多久更新一次？',
    answer: '韩漫星球的热门连载作品通常每周更新一次，部分热门作品可能每周更新两次。我们与多家韩国漫画平台保持合作，确保以最快的速度同步更新最新章节。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '您可以通过网站顶部的搜索栏直接搜索漫画名称，也可以通过首页的分类导航浏览不同类型。我们还提供热门推荐和最新更新列表，帮助您发现有趣的新作品。',
  },
  {
    question: '支持下载离线阅读吗？',
    answer: '目前韩漫星球暂不支持下载离线阅读功能。我们的服务专注于在线即时阅读体验，但这意味着您无需占用手机存储空间，随时随地只要有网络就能阅读所有漫画。',
  },
];

export const aboutContent = {
  brandIntro: '韩漫星球成立于2022年，是国内领先的韩国漫画在线免费阅读平台。我们致力于为中文读者提供最全面、最优质的韩国漫画资源，打造极致的下拉式阅读体验。从创立之初，我们就以"让每一位读者都能免费享受优质韩漫"为使命，不断丰富漫画库，优化阅读体验。',
  brandStory: '创始团队由一群热爱韩国漫画的资深读者和技术专家组成。我们深知国内韩漫爱好者面临的资源分散、更新滞后、阅读体验差等痛点。因此，韩漫星球从诞生之日起，就以用户需求为核心，持续引进优质韩漫资源，优化产品体验。经过数年发展，我们已经积累了超过3200部正版韩漫资源和850万活跃用户，成为国内韩漫爱好者首选的阅读平台。',
  contactEmail: 'hello@911hl.cn',
  businessEmail: 'hello@911hl.cn',
  address: '北京市朝阳区望京SOHO T3-A座 2508室',
  phone: '010-8888-6666',
};